import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

type SubstantiateResponse = {
  markdown: string;
};

export const useSubstantiateMeetingNote = (eventId: string, clientId: string) => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation<{ data: SubstantiateResponse }, Error, string>({
    mutationFn: (meetingNoteId: string) =>
      api.post<SubstantiateResponse>(
        `clients/${clientId}/meeting-notes/${meetingNoteId}/substantiate`,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['calendar-events', eventId, 'meeting-notes'] });
    },
  });

  return {
    substantiate: mutateAsync,
    isSubstantiating: isPending,
  };
};
